import { defineStore } from 'pinia';

import * as state from './financialaccount.state';
import * as getters from './financialaccount.getters';
import * as actions from './financialaccount.actions';

export const useFinancialAccountStore = defineStore('financialaccount', () => ({
  ...state,
  ...getters,
  ...actions
}));
